import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Daisy } from "./Daisy";

export const CookieBar = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("hm_cookies")) {
      const t = setTimeout(() => setShow(true), 2200);
      return () => clearTimeout(t);
    }
  }, []);
  const choose = (v) => {
    localStorage.setItem("hm_cookies", v);
    setShow(false);
  };
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-bar"
          className="fixed bottom-4 left-0 right-0 z-[90] mx-auto w-[calc(100%-2rem)] max-w-xl"
          initial={{ y: 140, opacity: 0, scale: 0.9 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: 140, opacity: 0, rotate: -3 }}
          transition={{ type: "spring", stiffness: 160, damping: 16 }}
        >
          <div className="relative mt-8 rounded-[2rem] border border-[#E2DACB] bg-white/95 backdrop-blur-xl p-5 pt-12 text-center shadow-[0_20px_50px_-20px_rgba(45,52,38,.45)]">
            <div className="absolute left-0 right-0 top-[-26px] flex justify-center">
              <motion.span className="inline-flex h-[74px] w-[74px] items-center justify-center rounded-full border-4 border-white bg-[#A3AC86] shadow-md" animate={{ rotate: 360 }} transition={{ duration: 14, repeat: Infinity, ease: "linear" }}>
                <Daisy size={52} />
              </motion.span>
            </div>
            <p className="h-section text-xl mt-3">Sušenky? My máme kopretiny!</p>
            <p className="text-sm text-[#6E7565] mt-1 max-w-md mx-auto">
              Používáme cookies, aby košík držel vaše poklady a web kvetl. Analytické cookies jen s vaším souhlasem.{" "}
              <Link to="/gdpr" className="underline decoration-[#F2C230] decoration-2 underline-offset-2" data-testid="cookie-more-link">Více info</Link>
            </p>
            <div className="mt-4 flex flex-wrap justify-center gap-2">
              <button className="btn-ghost" onClick={() => choose("necessary")} data-testid="cookie-necessary-btn">Jen nezbytné</button>
              <button className="btn-sage" onClick={() => choose("all")} data-testid="cookie-accept-btn">Přijmout vše</button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
